/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

"use client";

import { useState, useCallback } from "react";

import { fetchSdkDownload } from "./sdk.fetch";

export const useSdkDownloadTrigger = (): {
	triggerDownload: (archive_id: number, archive_type: string) => Promise<void>;
	isLoading: boolean;
	error?: string;
} => {
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | undefined>();

	const triggerDownload = useCallback(async (archive_id: number, archive_type: string) => {
		setIsLoading(true);
		setError(undefined);

		try {
			await fetchSdkDownload({ archive_id, archive_type });
		} catch (err) {
			const errorMessage = err instanceof Error ? err.message : "Download failed";
			setError(errorMessage);
			throw err;
		} finally {
			setIsLoading(false);
		}
	}, []);

	return {
		triggerDownload,
		isLoading,
		error,
	};
};
